import image from "../../images/help-customer.svg"
import circle from "../../images/circle.svg"

export default function HelpSupport() {
  return (
    <>
      <div className="gray mb-10 lg:mb-20">
        <section className="px-5 2xl:px-0 md:grid grid-cols-2 gap-10 items-center xl:max-w-6xl xl:mx-auto py-10 lg:py-28">
          <article>
            <h2 className="text-3xl lg:text-5xl mb-5 lg:mb-10">
              Customer support
            </h2>
            <p className="mb-5">
              We've got you covered! Our friendly customer service team's main
              aim is to provide support and help with any issues or problems you
              might have. We are here to help.
            </p>
            <ul>
              <li className="flex items-center font-bold">
                <img
                  src={circle}
                  alt="Circle"
                  title="Circle"
                  className="mr-5"
                />
                Competent Customer Support;
              </li>
              <li className="flex items-center font-bold my-5">
                <img
                  src={circle}
                  alt="Circle"
                  title="Circle"
                  className="mr-5"
                />
                Consulting;
              </li>
              <li className="flex items-center font-bold">
                <img
                  src={circle}
                  alt="Circle"
                  title="Circle"
                  className="mr-5"
                />
                Success Manager;
              </li>
            </ul>
          </article>

          <article className="mt-10 md:mt-0">
            <img
              src={image}
              alt="Customer support"
              title="Customer support"
              className="block mx-auto"
            />
          </article>
        </section>
      </div>
    </>
  )
}
